import { Button, Dialog, DialogActions, DialogContent, DialogTitle, TextField } from '@mui/material';
import React, { useEffect, useMemo, useState } from 'react';

const ConfirmationDialog = ({ message, onSubmit = (password = '') => { }, isOpen = false, onClose = () => { } }) => {

  const [password, setPassword] = useState('');

  const isValid = useMemo(() => password.length === 6, [password]);

  const handleSubmit = async () => {
    onClose()
    await onSubmit(password);
  }

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newPassword = e.target.value;

    if (/\D/gi.test(newPassword) || newPassword.length > 6) return;

    setPassword(newPassword);
  }

  useEffect(() => {
    if (isOpen) setPassword('');
  }, [isOpen])

  return (
    <Dialog open={isOpen} onClose={onClose}>
      <DialogTitle>
        Confirmação
      </DialogTitle>
      <DialogContent>
        {message}
        <TextField
          variant='filled'
          fullWidth
          sx={{ mt: 2 }}
          value={password}
          onChange={handleChange}
          label="Sua senha de 4 digitos aqui."
          inputProps={{ type: 'password', maxLength: 6, pattern: '[0-9]*' }}
          inputMode='numeric'
        />
      </DialogContent>
      <DialogActions>
        <Button disabled={!isValid} onClick={handleSubmit} >Confirmar</Button>
        <Button onClick={onClose}>Cancelar</Button>
      </DialogActions>
    </Dialog>
  );
}

export { ConfirmationDialog };

